module.exports = __webpack_public_path__ + "static/media/0324_IMG_LES_MURS_TRUFFLE_W_VTR2100_VERTICALE.32cf788e.webp";